import { useFormik } from 'formik';
import React, { useState } from 'react'
import { Row, Col, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { COUPON__ADDED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING__COUPON } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline';
import { paymentIntialValues, paymentVS } from './Helper';
import FeatherIcon from 'feather-icons-react';

// import { loadStripe } from '@stripe/stripe-js';
import Stripe from './Stripe';
import { addCoupon } from 'utlis/Apis/Coupon_API ';
// import FormSaleAddress from './FormSaleAddress';
import { createAddressIntialValues, createAddressVS } from '../Helper';
import FormPurchaseAddress from './FormPurchaseAddress';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe('pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3');


function Sidebar(props) {
    const { authState, token_id } = props
    const { vendor, bAddress, sAddress, setBAddress, setSAddress, order, setOrder, countries,
        coupon_code, setCoupon, manual_discount, setManualDiscount, formik, lines } = props
    let total = 0
    lines.forEach(line => {
        total = total + (((line.quantity || 0) * (line.variant_price || (line.price || 0))) || (line.variant_price || (line.price || 0)))
    });
    let final = (total || 0) + (parseInt(order.shippingCost) || 0) - (parseInt(order.discount) || 0)

    let weight = 0
    lines.forEach(line => {
        weight = weight + (((line.quantity || 0) * (line.variant_weight || (line.weight || 0))))
    });

    const [shippingAddress, setShippingAddress] = useState(false)
    const [billingAddress, setBillingAddress] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)
    const [paymentDetails_, setPaymentDetails_] = useState({})

    const temp_order_id = token_id
    const addCoupon_ = () => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        addCoupon(headers, coupon_code, temp_order_id, vendor.user_id).then(res => {
            setGlobalLoading(false)
            const couponData = res.data
            if (couponData.success) {
                setCreateButtonLoading(false)
                window.scrollTo(0, 0)
                formik.resetForm()
                toast.dismiss();
                toast.success(COUPON__ADDED_SUCCESSFULLY, {
                    autoClose: 2000,
                    onClose: () => {
                        props.history.push('/vendors', {
                            shouldReload: true
                        })
                    }
                })
            }
            if (couponData.error) {
                console.log(ERROR_WHILE_CREATING__COUPON, res)
                setCreateButtonLoading(true)
                toast.dismiss();
                toast.error(ERROR_WHILE_CREATING__COUPON, {
                    autoClose: 3000,
                    onClose: () => {
                        setGlobalLoading(false)
                        setCreateButtonLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} createCoupon `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setGlobalLoading(false)
                    setCreateButtonLoading(false)
                }
            })
        })
    }

    const submitPaymentDetails = values => {
        setPaymentDetails_(values)
    }

    const pformik = useFormik({
        initialValues: paymentIntialValues(paymentDetails_),
        validationSchema: paymentVS,
        onSubmit: submitPaymentDetails,
        enableReinitialize: true
    })


    const sformik = useFormik({
        initialValues: { ...createAddressIntialValues, ...sAddress },
        validationSchema: createAddressVS,
        onSubmit: (address) => {
            setSAddress(address)
            setShippingAddress(false)
        },
    })
    const bformik = useFormik({
        initialValues: { ...createAddressIntialValues, ...bAddress },
        validationSchema: createAddressVS,
        onSubmit: (address) => {
            setBAddress(address)
            setBillingAddress(false)
        },

    })

    return (
        <React.Fragment>
            <div>
                <div className="app-card-content border st-border-dark st-default-rounded-block overflow-hidden summary-card">
                    <div className="app-card-content st-border-light">
                        <div className="row gx-5">
                            <div className="col">
                                <h5>Summary</h5>
                                <div className="d-flex justify-content-between">
                                    <label>Subtotal</label>
                                    <span>${total || 0.00}</span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <label>Shipping</label>
                                    <span>${order.shippingCost || 0.00}</span>
                                </div>
                                {(!order.discount || order.discount === "0") ? "" : <div className="d-flex align-items-center justify-content-between">
                                    <label>Manual Discount</label>
                                    <span>${order.discount || 0.00}</span>
                                </div>}
                                <div className="d-flex justify-content-between grand-total">
                                    <label>
                                        <strong>Grand Total</strong>
                                    </label>
                                    <span>
                                        <strong>${final}</strong>
                                    </span>
                                </div>
                                <div className="divider pt-0 mb-1"></div>
                            </div>
                        </div>
                        <div className="row gx-5">
                            <div className="col">
                                <label>Manual Discount</label>
                                <div className="d-flex align-items-center justify-content-between manual-discount">
                                    <input
                                        className="form-control"
                                        placeholder="Manual Discount"
                                        id="manual_discount"
                                        value={manual_discount || 0}
                                        type="number"
                                        onChange={(e) => {
                                            setManualDiscount(e.target.value)
                                        }}
                                    />
                                    <button className="st-btn no-min-width st-btn-primary ms-3 min-height-auto"
                                        onClick={() => {
                                            order.discount = manual_discount
                                            setOrder(order)
                                            setManualDiscount("")
                                        }}
                                    >Apply</button>
                                </div>
                                <div className="divider mb-1"></div>
                            </div>
                        </div>
                        <div className="row gx-5">
                            <div className="col">
                                <label>Coupon on Gift certificate</label>
                                <div className="d-flex align-items-center justify-content-between">
                                    <input
                                        className="form-control"
                                        placeholder="Coupon Code"
                                        id="coupon_code"
                                        value={coupon_code}
                                        type="text"
                                        onChange={(e) => { setCoupon(e.target.value) }}
                                    />
                                    <button className="st-btn no-min-width st-btn-primary ms-3 st-btn-xs min-height-auto apply-coupon"
                                        onClick={addCoupon_}>
                                        {
                                            createButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                " Apply"
                                            )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="app-card-content border st-border-dark st-default-rounded-block overflow-hidden summary-detail-card">
                    <div className="app-card-content st-border-light">

                        <Row className="gx-5 mb-10">
                            <Col>
                                <h5>Vendor</h5>
                                <div className="user-img">
                                    <img src="https://images.pexels.com/users/avatars/224453/andrea-piacquadio-138.jpeg?auto=compress&fit=crop&h=256&w=256" alt="img" />
                                </div>
                                <div className="d-flex flex-column">
                                    <label>
                                        <strong>{vendor.first_name}</strong>
                                    </label>
                                    <span>{vendor.phone || "phone"}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className="gx-5 mb-10">
                            <Col>
                                <span className="edit-btn"
                                    onClick={() => { props.setGoSteps(2) }}
                                >
                                    <FeatherIcon
                                        icon="edit"
                                        size="15"
                                        className="icon" />
                                </span>

                                <h5>Shipping Details</h5>
                                <div className="d-flex align-items-center">
                                    <label>
                                        <strong>Vendor's choice:</strong>
                                    </label>
                                    <span className="text-capitalize">{order.shippingType}, ${order.shippingCost}</span>

                                </div>
                                <div className="d-flex align-items-center">
                                    <label>
                                        <strong>Weight:</strong>
                                    </label>
                                    <span>${weight} lbs</span>
                                </div>
                                {/* <div className="d-flex align-items-center">
                                    <div className="text-primary">Add Tracking Number &nbsp;
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                                    </div>
                                </div> */}
                            </Col>
                        </Row>
                        <Row className="gx-5">
                            <Col>
                                {!billingAddress ?
                                    <span className="edit-btn"
                                        // onClick={() => { props.setGoSteps(0) }}
                                        onClick={() => {
                                            setBillingAddress(true)
                                        }}
                                    >
                                        <FeatherIcon
                                            icon="edit"
                                            size="15"
                                            className="icon" />
                                    </span>
                                    :
                                    <span className="remove-btn"
                                        onClick={() => {
                                            setBillingAddress(false)
                                        }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg>
                                    </span>
                                }

                                <h5 className={"mb-4"}>Billing Address</h5>
                                {!billingAddress &&
                                    <address className="text-capitalize">
                                        <p >{bAddress.shipping_address}</p>
                                        <p>{bAddress.city}, {" "}{bAddress.state},{" "}{bAddress.shipping_zipcode}</p>
                                        <p>{bAddress.country}</p>
                                        <p>{bAddress.shipping_phone}</p>
                                        {/* <div className="map-btn text-primary">See on map &nbsp;
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                            </svg>
                                        </div> */}
                                    </address>}
                                {billingAddress &&
                                    <Row className="gx-5">
                                        <Col>
                                            <form onSubmit={bformik.handleSubmit} noValidate autoComplete="off" className="address-form">
                                                <FormPurchaseAddress
                                                    countries={countries}
                                                    formik={bformik}
                                                />
                                                <div className="app-card-content st-border-light d-flex align-items-center justify-content-end">
                                                    <button
                                                        type="button"
                                                        className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto`}
                                                        onClick={e => { setBillingAddress(false) }}
                                                    >
                                                        <FeatherIcon
                                                            icon="rotate-ccw"
                                                            size="14"
                                                            className="icon me-1" />
                                                        <span>Close</span>
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center min-height-auto`}
                                                    >
                                                        <FeatherIcon
                                                            icon="download"
                                                            size="14"
                                                            className="icon me-1" />
                                                        <span>Save</span>
                                                    </button>
                                                </div>
                                            </form>

                                        </Col>
                                    </Row>}
                                <div className="divider"></div>

                            </Col>
                        </Row>


                        <form
                            onSubmit={pformik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            <Row className="payment-details">
                                <Col className="mb-10" lg={12}>
                                    <h5>Payment Details</h5>

                                    <AppFormikSelectInline
                                        formik={pformik}
                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                        labelName={""}
                                        formikFieldName="payType"
                                        isRequired={true}
                                        // formikFieldName={"card"}
                                        onChange={(e) => {
                                            order.payment_processor = e
                                            setOrder(order)
                                        }}
                                    >
                                        <option disabled>Select Card</option>
                                        <option value="CASH">Cash</option>
                                        <option value="STRIPE">Credit Card</option>
                                    </AppFormikSelectInline>
                                    {order.payment_processor === "STRIPE" ? <Stripe final={final} /> : ""}
                                </Col>
                                {/* {paymentDetails && */}
                                {/* <>
                                    <AppFormikInputInline
                                        formik={pformik}
                                        stFormClass={"st-from st-form-with-label-left d-flex flex-wrap align-items-center"}
                                        labelName={"Card Holder"}
                                        isRequired={true}
                                        placeholder={"Card Holder"}
                                        formikFieldName={"cardholder"}
                                    />
                                    <AppFormikSelectInline
                                        formik={pformik}
                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                        labelName={"Card Type"}
                                        isRequired={true}
                                        formikFieldName={"cardtype"}
                                    >
                                        <option disabled>Visa</option>
                                        <option value="0">Visa1</option>
                                        <option value="1">Visa2</option>
                                    </AppFormikSelectInline>

                                    <div className="d-flex flex-wrap align-items-center justify-content-end visa-logo">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="" />
                                    </div>

                                    <AppFormikInputInline
                                        formik={pformik}
                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                        labelName={"Credit Card No"}
                                        isRequired={true}
                                        placeholder={"xxxx-xxxx-xxxx-xxxx"}
                                        formikFieldName={"creditcardno"}
                                    />
                                    <div className="d-flex">
                                        <AppFormikSelectInline
                                            formik={pformik}
                                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                            labelName={"Expiration Date "}
                                            isRequired={true}
                                            formikFieldName={"expiration_date"}
                                        >
                                            <option disabled value="">Select Status</option>
                                            <option value="jan">jan</option>
                                        </AppFormikSelectInline>

                                        <AppFormikSelectInline
                                            formik={pformik}
                                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center ms-1"}
                                            labelName={""}
                                            formikFieldName={"expiration_year"}
                                        >
                                            <option disabled value="">Select Year</option>
                                            <option value="2021">2021</option>
                                        </AppFormikSelectInline>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                        <button className="st-btn st-btn-gray no-min-width ms-3 st-btn-sm"
                                            type="button"
                                            onClick={() => {
                                                pformik.resetForm()
                                            }}
                                        >
                                            <FeatherIcon
                                                icon="rotate-ccw"
                                                size="14"
                                                className="icon me-1" />
                                            <span>Reset</span>
                                        </button>
                                        <button className="st-btn st-btn-primary ms-2 no-min-width st-btn-sm"
                                            onClick={handleFormSubmission}
                                            type="submit">
                                            <FeatherIcon
                                                icon="download"
                                                size="14"
                                                className="icon me-1" />
                                            <span>Save</span>
                                        </button>
                                    </div>
                                </> */}
                                {/* } */}
                            </Row>
                        </form>

                        <Row className="gx-5">
                            <Col>
                                {!shippingAddress ?
                                    <span className="edit-btn"
                                        onClick={() => {
                                            setShippingAddress(true)
                                        }}
                                    >
                                        <FeatherIcon
                                            icon="edit"
                                            size="15"
                                            className="icon" />
                                    </span>
                                    :
                                    <span className="remove-btn"
                                        onClick={() => {
                                            setShippingAddress(false)
                                        }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg>
                                    </span>
                                }

                                <h5 className={"mb-4"}>Shipping Address</h5>
                                {!shippingAddress &&
                                    <address className="text-capitalize">
                                        <p >{sAddress.shipping_address}</p>
                                        <p>{sAddress.city}, {" "}{sAddress.state},{" "}{sAddress.shipping_zipcode}</p>
                                        <p>{sAddress.country}</p>
                                        <p>{sAddress.shipping_phone}</p>
                                        {/* <div className="map-btn text-primary">See on map &nbsp;
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                            </svg>
                                        </div> */}
                                    </address>}
                                {shippingAddress &&
                                    <Row className="gx-5">
                                        <Col>
                                            <form onSubmit={sformik.handleSubmit} noValidate autoComplete="off" className="address-form">
                                                <FormPurchaseAddress
                                                    countries={countries}
                                                    formik={sformik}
                                                />

                                                <div className="app-card-content st-border-light d-flex align-items-center justify-content-end">
                                                    <button
                                                        type="button"
                                                        className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto`}
                                                        onClick={() => {
                                                            setShippingAddress(false)
                                                        }}
                                                    >
                                                        <FeatherIcon
                                                            icon="rotate-ccw"
                                                            size="14"
                                                            className="icon me-1" />
                                                        <span>Close</span>
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center min-height-auto`}
                                                    >
                                                        <FeatherIcon
                                                            icon="download"
                                                            size="14"
                                                            className="icon me-1" />
                                                        <span>Save</span>
                                                    </button>
                                                </div>
                                            </form>
                                        </Col>
                                    </Row>}
                                <div className="divider"></div>

                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Sidebar)